import i18n from "@/i18n";

const SPECIFIC = 'specific';

/**
 * @typedef {Object} StaticBinding
 * @property {number} id
 * @property {string} code
 */

/**
 * @typedef {Object} FieldWithStaticBinding
 * @property {StaticBinding} static_binding
 * @property {string} field
 */

/**
 * @param {FieldWithStaticBinding[]} bindings
 * @returns {Object.<string, FieldWithStaticBinding[]>}
 */
export const regroupBindings = (bindings) => {
    const outputObject = {};

    for (const item of bindings) {
        const codeSplit = item.static_binding.code.split('.');
        const codeName = codeSplit.length > 1 ? codeSplit[0] : SPECIFIC;

        if (!outputObject[codeName]) {
            outputObject[codeName] = [];
        }

        const label = codeName === SPECIFIC ? i18n.t(`${SPECIFIC}.${item.static_binding.code}`) : i18n.t(item.static_binding.code)

        outputObject[codeName].push({...item, label});
    }

    for (const key in outputObject) {
        if (Object.hasOwn(outputObject, key)) {
            outputObject[key] = sortBindings(outputObject[key]);
        }
    }
    return outputObject;
}


const sortBindings = (bindings) => {
    return bindings.sort((a, b) => {
        const codeA = a.label;
        const codeB = b.label;
        return codeA.localeCompare(codeB);
    });
}
